'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable indent */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _webComponents = require('@vezeeta/web-components');

var _gridStyled = require('grid-styled');

var _Header = require('./Header.style');

var _RoleBasedAccess = require('../../RoleBasedAccess');

var _IconsStore = require('../../../IconsStore');

var _IconsStore2 = _interopRequireDefault(_IconsStore);

require('./Header.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(props) {
  var doctorPhoto = props.doctorPhoto,
      doctorName = props.doctorName,
      doctorEmail = props.doctorEmail,
      title = props.title,
      tabs = props.tabs,
      cdnUrl = props.cdnUrl,
      onSignOut = props.onSignOut,
      payLater = props.payLater,
      enablePayLater = props.enablePayLater,
      manageBranches = props.manageBranches,
      subsciptions = props.subsciptions,
      breadcrumbProps = props.breadcrumbProps,
      language = props.language,
      user = props.user,
      onLanguageChange = props.onLanguageChange,
      supportSingleLanguage = props.supportSingleLanguage;

  var headerItems = void 0;
  var doctorDetails = void 0;
  var isMobile = window.innerWidth <= 1023;

  if (title) {
    headerItems = _react2.default.createElement(
      _Header.HeadersTitles,
      { className: 'page-title' },
      title
    );
  } else if (tabs.length !== 0) {
    headerItems = tabs.map(function (item) {
      return item.enable && _react2.default.createElement(
        _reactRouterDom.NavLink,
        {
          className: 'tab',
          activeClassName: 'tab--active',
          href: item.url,
          to: item.url,
          key: item.title
        },
        _react2.default.createElement(
          _Header.HeadersTitles,
          { cursor: 'pointer', className: 'text' },
          item.title
        )
      );
    });
  } else {
    headerItems = _react2.default.createElement(
      _gridStyled.Flex,
      { px: 4 },
      _react2.default.createElement(_webComponents.Breadcrumb, _extends({}, breadcrumbProps, { fontType: _webComponents.FONT_TYPES.SUBHEADING }))
    );
  }

  var doctorImage = doctorPhoto !== '' ? doctorPhoto : cdnUrl + '/assets/user-placeholder-blue.png';

  var CountryIsoCode = user.CountryIsoCode,
      CountryId = user.CountryId;


  var onClickHotLine = function onClickHotLine(number) {
    window.location = 'tel:' + number;
  };

  if (doctorName && !doctorName.includes('undefined')) {
    var items = [{
      component: _react2.default.createElement(_webComponents.UserPreview, {
        name: doctorName,
        email: doctorEmail,
        photo: doctorImage,
        fallbackPhoto: cdnUrl + '/assets/user-placeholder.png',
        reverse: language !== 'en'
      })
    }, {
      isDivider: true
    }, {
      // icon: IconsStore.getIcon('credit'),
      text: language === 'en' ? 'Add Credit Card Info' : 'أضف كارت الإئتمان',
      onClick: payLater,
      disabled: enablePayLater
    }, {
      // icon: IconsStore.getIcon('clinic'),
      text: language === 'en' ? 'Manage Branch(es)' : 'إدارة الفرع',
      onClick: manageBranches,
      disabled: !window.enableManageBranches
    }];

    if (window.countriesSupportSubscriptions.includes(CountryId)) {
      items = [].concat(items, [{
        // icon: IconsStore.getIcon('renew'),
        text: language === 'en' ? 'Subscription Packages' : 'باقات الاشتراك',
        onClick: subsciptions,
        disabled: !((0, _RoleBasedAccess.getUserRole)() === _RoleBasedAccess.USER_ROLES.SINGLE_DR_APP || (0, _RoleBasedAccess.getUserRole)() === _RoleBasedAccess.USER_ROLES.OWNER)
      }]);
    }

    if (!supportSingleLanguage) {
      var options = [{
        name: language === 'en' ? 'English' : 'الإنجليزية',
        key: 'en',
        isSelected: language === 'en'
      }, {
        name: language === 'en' ? 'Arabic' : 'العربية',
        key: 'ar',
        isSelected: language === 'ar'
      }];

      items.push({
        text: language === 'en' ? 'Language: English' : 'اللغة: العربية',
        onClick: function onClick() {
          return onLanguageChange(language);
        },
        disabled: false,
        isExpandable: true,
        options: options
      });
    }

    items = window.hotLines[CountryIsoCode] && window.hotLines[CountryIsoCode][language] ? [].concat(items, [{
      isDivider: true
    }, {
      // icon: window.hotLines[CountryIsoCode] ? IconsStore.getIcon('phone') : null,
      text: window.hotLines[CountryIsoCode] ? (language === 'en' ? 'Support: ' : 'الدعم: ') + ' ' + window.hotLines[CountryIsoCode][language] : null,
      onClick: function onClick() {
        return onClickHotLine(window.hotLines[CountryIsoCode].en);
      },
      isBold: true,
      isHighlighted: true
    }, {
      isDivider: true
    }, {
      // icon: IconsStore.getIcon('logout'),
      text: language === 'en' ? 'Logout' : 'تسجيل الخروج',
      onClick: onSignOut
    }]) : [].concat(items, [{
      isDivider: true
    }, {
      icon: _IconsStore2.default.getIcon('logout'),
      text: language === 'en' ? 'Logout' : 'تسجيل الخروج',
      onClick: onSignOut
    }]);

    doctorDetails = _react2.default.createElement(
      _react.Fragment,
      null,
      _react2.default.createElement(_webComponents.DropDown, {
        items: items,
        menuAlignment: language === 'en' ? 'RIGHT' : 'LEFT',
        component: _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            _Header.DoctorName,
            { language: language },
            doctorName
          ),
          _react2.default.createElement(_webComponents.Image, {
            src: doctorImage,
            alt: 'doctor',
            fallback: cdnUrl + '/assets/user-placeholder-blue.png',
            radius: 30,
            name: doctorName
          })
        )
      })
    );
  } else {
    doctorDetails = _react2.default.createElement(
      _webComponents.ShimmerEffect,
      null,
      _react2.default.createElement(
        _webComponents.NoAnimationFlex,
        { className: 'doctor-info--loading' },
        !isMobile && _react2.default.createElement(_webComponents.Rect, { mr: 3, className: 'doctor-name' }),
        _react2.default.createElement(_webComponents.Circle, { className: 'doctor-photo' })
      )
    );
  }

  return _react2.default.createElement(
    _Header.HeaderContainer,
    { language: language },
    _react2.default.createElement(
      'div',
      { className: 'header-tabs--container' },
      headerItems
    ),
    _react2.default.createElement(
      'div',
      { className: 'doctor-info--container' },
      doctorDetails
    )
  );
};

Header.propTypes = process.env.NODE_ENV !== "production" ? {
  tabs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    title: _propTypes2.default.string,
    url: _propTypes2.default.string,
    enable: _propTypes2.default.bool
  })),
  title: _propTypes2.default.string,
  breadcrumbProps: _propTypes2.default.object,
  doctorName: _propTypes2.default.string,
  doctorEmail: _propTypes2.default.string,
  doctorPhoto: _propTypes2.default.string,
  onSignOut: _propTypes2.default.func.isRequired,
  enablePayLater: _propTypes2.default.bool.isRequired,
  payLater: _propTypes2.default.func.isRequired,
  manageBranches: _propTypes2.default.func.isRequired,
  cdnUrl: _propTypes2.default.string.isRequired,
  language: _propTypes2.default.string.isRequired,
  user: _propTypes2.default.object,
  subsciptions: _propTypes2.default.func.isRequired,
  onLanguageChange: _propTypes2.default.func.isRequired,
  supportSingleLanguage: _propTypes2.default.bool.isRequired
} : {};

Header.defaultProps = {
  doctorName: '',
  doctorEmail: '',
  doctorPhoto: '',
  title: undefined,
  tabs: undefined,
  breadcrumbProps: undefined,
  user: undefined
};

exports.default = Header;
module.exports = exports['default'];